module.exports = __webpack_public_path__ + "media/images/background-photo-3-1@1x-e03577a9aa84826e5e7502da7110afd2.png";